import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { FlexContainer, PerfectCenter, PureSpinner } from 'heliocor-ui'

import { SET_STEP_INDEX } from '../store/cafe/actionTypes'
import { ApplicationComplete } from '../components/summary/ApplicationComplete'
import { ApplicationSummary } from '../components/summary/ApplicationSummary'
import { PostErrorsButton } from '../components/summary/PostErrorsButton'

const getSummaryDetailDocuments = ({documents, documentsRequest, isRequest}) => {
    const requestDocumentsNames = [];

    documentsRequest && documentsRequest
        .forEach(doc => doc.documents && doc.documents
            .forEach(doc => requestDocumentsNames.push(doc.name)))

    const preApprovalDocs = documents.filter(doc => !isEmpty(doc.datas))
    const requestDocs = documents.filter(doc => requestDocumentsNames.includes(doc.type) && !isEmpty(doc.datas))
    return isRequest ? requestDocs : preApprovalDocs
}

export const Summary = ({ id, documentsRequest = [] }) => {

    const dispatch = useDispatch()

    const entity = useSelector(store => store.party.data)
    const connectedParties = useSelector(store => store.party.connectedParties)
    const documents = useSelector(store => store.party.documents) || []
    const partyType = useSelector(store => store.config.partyType)
    const stepsList = useSelector(store => store.navigation.stepsList)
    const cafeStatus = useSelector(state => state.general.cafeStatus)
    const isRequest = useSelector(state => state.config.isRequest)
    const entityLoading = !useSelector(state => state.settings?.entity)
       
    const formSubmitted = cafeStatus === "SUBMITTED"
    const summaryDocuments = getSummaryDetailDocuments({documents, documentsRequest, isRequest})

    const handleChangeStep = (stepId) => {
        const stepIndex = stepsList.findIndex(step => step === stepId)
        stepIndex !== -1 && dispatch({ type: SET_STEP_INDEX, stepIndex })
    }

    if(entityLoading) return <PerfectCenter><PureSpinner /></PerfectCenter>

    if(formSubmitted) return <ApplicationComplete />

    return (
        <FlexContainer column width='100%'>
            <ApplicationSummary
                entity={entity}
                connectedParties={connectedParties}
                documents={summaryDocuments}
                partyType={partyType}
                handleChangeStep={handleChangeStep}
                canEdit={id === "summary"}
                id={id}
                stepsList={stepsList}
            />
            <PostErrorsButton />
        </FlexContainer>
    )
}
